import DefaultController from 'root/main/core/ajax/ajaxContentControllers/defaultController';
import { isMobile } from 'root/utils/isMobile';
import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';

export default class AlertBannerController extends DefaultController {
    getElementToChange() {
        return ['#content-wrapper'];
    }

    load() {
        if (
            !this.hasCookie(this.getCookieName()) &&
            this.isCookieNotificationSetOnMobile()
        ) {
            this.elementToInsert = this.gethtmlToInsert();
            this.addEventListenerToElement();
            this.insertElement();
            this.postInsertActions();
        }
    }

    insertElement() {
        let fn = this[this.data.DOMinsert.method];

        // var elToInsert = this.
        if (typeof fn === 'function') {
            fn(this.data.DOMinsert.target, this.elementToInsert);
        }
    }

    postInsertActions() {
        let change = this.getElementToChange();
        change.forEach(function (target) {
            let el = document.querySelector(target);
            el.classList.add('js-banner-display');
            el.classList.remove('js-banner-null');
        });
        this.titleElement = document.querySelector('.alert-banner__text');
        gtm.alertBanner(this.titleElement).sendEvent('shown');
    }

    postClosedActions() {
        let change = this.getElementToChange();
        change.forEach(function (target) {
            let el = document.querySelector(target);
            el.classList.remove('js-banner-display');
            el.classList.add('js-banner-null');
        });
        gtm.alertBanner(this.titleElement).sendEvent('exit');
    }

    setAlertBannerCookie() {
        this.cm.setCookie(this.getCookieName(), 1, 90);
    }

    addEventListenerToElement() {
        let closeBtn = this.elementToInsert.querySelector(
            `[data-alert=close-btn_${this.name}]`
        );
        let ctaBtn = this.elementToInsert.querySelector(
            `[data-alert=cta-btn_${this.name}]`
        );
        closeBtn.addEventListener('click', this.closeHandler.bind(this));
        if (ctaBtn) {
            ctaBtn.addEventListener('click', this.ctaClickHandler.bind(this));
        }
    }

    closeHandler(e) {
        e.preventDefault();
        this.setAlertBannerCookie();
        this.postClosedActions();
    }

    ctaClickHandler() {
        this.setAlertBannerCookie();
        gtm.alertBanner(this.titleElement).sendEvent('click');
    }

    hasCookie(cookieName) {
        if (cookieName) {
            return this.cm.getCookie(cookieName) === 1;
        }
    }

    // Checks if there is a cookie set for the cookie notification on mobile
    isCookieNotificationSetOnMobile() {
        if (isMobile.hasMobileDeviceSize()) {
            return this.hasCookie('_ls-cookie_notification');
        }
        return true;
    }

    getCookieName() {
        return '_ls-' + this.name;
    }
}
